export const loadCart = () => {
  try {
    return JSON.parse(localStorage.getItem("shoppingCart")) || [];
  } catch {
    return [];
  }
};

export const saveCart = (cart) => {
  localStorage.setItem("shoppingCart", JSON.stringify(cart));
  window.dispatchEvent(new Event("storage"));
};

export const addToCart = (product) => {
  const cart = loadCart();
  const existing = cart.find((i) => i.id === product.id);
  const unitPrice = Number(
    product.currentPriceRaw ??
      product.price ??
      0
  );
  const productImage = product.url || product.image || product.images?.[0] || "";

  if (existing) {
    existing.quantity += 1;
  } else {
    cart.push({
      id: product.id,
      name: product.name,
      category: product.category || "General",
      brand: product.brand || "QA Coder",
      description: product.description || "",
      price: unitPrice,
      url: productImage,
      image: productImage,
      discount: Number(product.discount || 0),
      stock: Number(product.stock || 0),
      color: product.color || "Default",
      highlights: Array.isArray(product.highlights) ? product.highlights : [],
      attributes: product.attributes || {},
      quantity: 1,
    });
  }

  saveCart(cart);
  return cart;
};

export const updateCartQuantity = (id, delta) => {
  const updatedCart = loadCart()
    .map((item) => {
      if (String(item.id) !== String(id)) {
        return item;
      }

      const nextQuantity = item.quantity + delta;
      return nextQuantity > 0 ? { ...item, quantity: nextQuantity } : null;
    })
    .filter(Boolean);

  saveCart(updatedCart);
  return updatedCart;
};

export const removeFromCart = (id) => {
  const updatedCart = loadCart().filter((item) => String(item.id) !== String(id));
  saveCart(updatedCart);
  return updatedCart;
};

export const clearCart = () => {
  localStorage.removeItem("shoppingCart");
  window.dispatchEvent(new Event("storage"));
};

export const getCartSummary = (cart = loadCart()) => {
  const items = cart.reduce((sum, item) => sum + item.quantity, 0);
  const subtotal = cart.reduce(
    (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
    0
  );
  const discount = subtotal >= 10000 ? Math.round(subtotal * 0.1) : subtotal > 0 ? 500 : 0;
  const delivery = subtotal > 0 ? 0 : 0;

  return {
    items,
    subtotal,
    discount,
    delivery,
    totalPayable: Math.max(0, subtotal - discount + delivery),
  };
};

export const getCartCount = () =>
  loadCart().reduce((sum, item) => sum + item.quantity, 0);

export const isInCart = (id) =>
  loadCart().some((item) => item.id === id);
